import React, { useState, useEffect } from "react";
import { Card } from "antd";
import { API_BASE_URL } from "../../Config";
import { motion } from "framer-motion";
import axios from "axios";
import "./DosAndDonts.css";
import AdvertisementCard from "../AdvertisementCard";

const DosAndDonts = () => {
  const [allPages, setAllPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDoDont = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/allpages?page=do-or-donts`,
        );
        setAllPages(res.data?.data || []);
      } catch (error) {
        console.error("API Fetch Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDoDont();
  }, []);

  if (loading) return <h2 className="center-text">Loading...</h2>;

  if (!allPages.length)
    return <h2 className="center-text">No content found</h2>;

  return (
    <div className="dos-page">
      <div>
        <motion.h1
          className="page-title"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Yoga ✅ Dos & ❌ Don’ts
        </motion.h1>

        <div className="dos-layout">
          {/* LEFT CONTENT */}
          <div className="dos-main">
            {allPages.map((item) => {
              const isDont =
                item.content.toLowerCase().includes("don't") ||
                item.content.toLowerCase().includes("dont");

              return (
                <Card
                  key={item._id}
                  className={`content-card ${isDont ? "dont" : "do"}`}
                >
                  <div
                    className="page-content"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  />
                </Card>
              );
            })}
          </div>

          {/* RIGHT ADS */}
        </div>

        <motion.p
          className="footer-note"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
        >
          Yoga is practiced not only with the body, but also with the mind.
        </motion.p>
      </div>
      <AdvertisementCard />
    </div>
  );
};

export default DosAndDonts;
